var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper"},[_c('img',{attrs:{"id":"img","src":require("../assets/img/02.png"),"alt":""}})])}]

export { render, staticRenderFns }